const validGlassProperties = {
  length: {
    min: 150,
  },
  maxWeight: {
    max: 1000,
    min: 20,
  },
  quantity: {
    max: 50,
    min: 1,
  },
};

export default validGlassProperties;
